import { exerciseKindSchema } from '@echo/core';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { MathLevelChoose } from '@/components/math-choose';

export const Route = createFileRoute('/_app/exercise/$kind/level')({
  params: {
    parse: ({ kind }) => ({ kind: exerciseKindSchema.parse(kind) }),
    stringify: ({ kind }) => ({ kind }),
  },
  component: ExerciseLevelPage,
});

/** Quick math › "Pick for me" › the difficulty; the other exercises have none. */
function ExerciseLevelPage() {
  const { kind } = Route.useParams();
  if (kind !== 'math') return <Navigate to="/exercise/$kind" params={{ kind }} replace />;
  return <MathLevelChoose />;
}
